import { z } from 'zod'

export const dischargeFormSchema = z.object({
  status: z.enum(['DISCHARGED', 'DECEASED'], {
    message: 'patients:discharge.errors.statusRequired',
  }),
  dischargeDate: z.string().min(1, 'patients:discharge.errors.dateRequired'),
  dischargeTime: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'patients:discharge.errors.invalidTime')
    .optional()
    .or(z.literal('')),
  notes: z.string().optional(),
})

export type DischargeFormValues = z.infer<typeof dischargeFormSchema>

export function getDischargeDefaultValues(): DischargeFormValues {
  return {
    status: 'DISCHARGED',
    dischargeDate: new Date().toISOString().split('T')[0],
    dischargeTime: '',
    notes: '',
  }
}
